import React, { useMemo, useState } from 'react'
import { NumberConvert } from '../../../common/numberConvert';
import Axios from 'axios';
import dayjs from 'dayjs';

const UserInfomation = ({ data, point, setUserPoints, userBuyTotal, setUserBuyTotal }) => {

  // 시간 불러오는 부분
  let toDate = new dayjs().format('YYYY-MM-DD');
  let toTime = new dayjs().format('YYYY-MM-DD HH:mm:ss')

  const minusDate = (number)=>{
    const now = new dayjs().subtract(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const plusDate = (number)=>{
    const now = new dayjs().add(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const toDay = {
    date: toDate,
    time: toTime,
    minusDate,
    plusDate
  }
  
  const basicName = window.sessionStorage.getItem('basicName');

  const [userPointTotal, setUserPointTotal] = useState([]);

  useMemo(()=>{
    let Mount = true;

    // 포인트 최다 및 최저 랭킹
    const UserPointData = async ()=>{
      await Axios.get('/api/Point_store/UserPointRank')
      .then((res)=>{
        if(Mount){
          setUserPointTotal(res.data);
        }
      })
    };
    UserPointData();

    return ()=>{
      Mount = false;
    }
  }, [])

  return (
    <div className='w-full'>

      <div className='flex flex-col gap-3 rounded-md tracking-wide'>

      {/* ⚡🔖🧾🪙 */}
        <div className='flex flex-col md:flex-row justify-between bg-[#3E3E3E] p-3 rounded-sm' style={{fontFamily: 'Gugi'}}>
          <div className='flex items-center gap-2 lg:z-10'>
            <p><span className='text-xl'>🪙 </span>{basicName} 님의 포인트</p>
            <p className={`${point < 1 && 'text-red-400 animate-pulse'}`}>{NumberConvert(point)} P</p>
          </div>
          <div className='flex gap-3 lg:z-10'>
            <p><span className='text-xl'>🧾 </span>구매 건 수 {`${NumberConvert(userBuyTotal)}`} 건</p>
          </div>
        </div>

        {/* 🥇🥈🥉 🏅🎖️🏆 🌿🍀🚬 */}

        {/* 랭킹 출력 */}
        {/* <p>포인트 랭킹</p> */}
        <div className='grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 w-full overflow-x-auto overflow-y-hidden' style={{fontFamily: 'Gugi'}}>
          {userPointTotal.map((data, index)=>(
            <div key={data.id} className='bg-[#3E3E3E] p-3 flex justify-center rounded-md relative w-full'>
              <div className='flex flex-col justify-center'>
                <p className='text-4xl absolute top-[-2px] left-[-8px]'>
                  {(index + 1 === 1 && '🥇') || (index + 1 === 2 && '🥈') || (index + 1 === 3 && '🥉') || '🌿'}
                </p>
                <div className='flex gap-1 whitespace-nowrap'>
                  {/* <p className='z-10'>{data.name}</p> */}
                  <p className=''>{data.id}</p>
                </div>
                <p className=''>{`${NumberConvert(data.Point_Total)} P`}</p>
              </div>
            </div>
          ))}
        </div>

      </div>

    </div>
  )
}

export default UserInfomation